import { render } from "./StudentRequirementSubmissionDataTable.vue?vue&type=template&id=73f61d7b&scoped=true"
import script from "./StudentRequirementSubmissionDataTable.vue?vue&type=script&lang=js"
export * from "./StudentRequirementSubmissionDataTable.vue?vue&type=script&lang=js"

import "./StudentRequirementSubmissionDataTable.vue?vue&type=style&index=0&id=73f61d7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f61d7b"]])

export default __exports__